"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AudioBitrateSelect = require("./AudioBitrateSelect");
Object.keys(_AudioBitrateSelect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioBitrateSelect[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioBitrateSelect[key];
    }
  });
});